import {HttpErrorResponse,HttpHeaders,HttpResponse} from '@angular/common/http';
import {Component,OnDestroy,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService,JhiEventManager,JhiParseLinks} from 'ng-jhipster';
import {BsModalRef,ModalDirective} from 'ngx-bootstrap';
import {Subscription,forkJoin} from 'rxjs';
import {Principal} from 'src/app/core';
import {ITEMS_PER_PAGE} from 'src/app/shared/constants/pagination.constants';
import {IInsuranceCompanyMySuffix} from 'src/app/shared/model/insurance-company-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {CommonUtils} from 'src/app/shared/util/common-utils';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {DelegationMySuffixService} from '../underwriter-insurer-my-suffix/delegation-my-suffix.service';
import {UnderwriterInsurerMySuffixService} from './../underwriter-insurer-my-suffix/underwriter-insurer-my-suffix.service';
import {InsuranceCompanyMySuffixService} from './insurance-company-my-suffix.service';



declare let $:any;
@Component({
    selector: 'jhi-insurance-company-my-suffix',
    templateUrl: './insurance-company-my-suffix.component.html'
})
export class InsuranceCompanyMySuffixComponent implements OnInit, OnDestroy {
    currentAccount: any;
    insuranceCompanies: IInsuranceCompanyMySuffix[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    searchText: string;
    flag: boolean;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    insuranceCompanyId: number;
    modalTitle: string = 'Confirm operation';
    modalContent: string;
    status: string = '';
    showActiveModel: boolean = false;
    incCompanyName: any;
    accessClientId: number
    accessPlatform: boolean = false;
    isLoginEmail: any;

    @ViewChild('insuranceCompanyAccessModal') insuranceCompanyAccessModal: ModalDirective;

    public readonly RoleUtil = RoleUtil;

    constructor(
        private insuranceCompanyService: InsuranceCompanyMySuffixService,
        private parseLinks: JhiParseLinks,
        private jhiAlertService: JhiAlertService,
        public principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: JhiEventManager,
        private languageChangeService: LanguageChangeService,
        private delegationService: DelegationMySuffixService,
        private underwriterInsurerService:UnderwriterInsurerMySuffixService
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
            // if (this.itemsPerPage == 25 && this.page > 1) {
            //     this.page = 1;
            //     this.previousPage = 1;
            // }
        });
                this.languageChangeService.refreshLanguage();
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            if (paramMap.get('size')) {
                this.itemsPerPage = paramMap.get('size')
            }
            const refresh = paramMap.get('refresh');
            if (refresh) {
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
    }

    loadAll() {
        this.searchText = '';
        this.insuranceCompanyService
            .query({
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<IInsuranceCompanyMySuffix[]>) => {
                    this.paginateInsuranceCompanies(res.body, res.headers);
                },
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        if (this.searchText) {
            this.searchItems();
            this.flag = true;
        } else {
            this.router.navigate(['/data-management/insurance-company'], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
            this.loadAll();
        }
    }

    clear() {
        this.page = 0;
        this.router.navigate([
            '/data-management/insurance-company',
            {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        ]);
        this.loadAll();
    }

    ngOnInit() {
        this.principal.setTitle("Insurance Companies");
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.loadAll();
        this.principal.identity().then(account => {
            this.currentAccount = account;
        });

        this.registerChangeInInsuranceCompanies();


    }

    ngOnDestroy() {
        if (this.eventSubscriber)
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: IInsuranceCompanyMySuffix) {
        return item.id;
    }

    registerChangeInInsuranceCompanies() {
        this.eventSubscriber = this.eventManager.subscribe('insuranceCompanyListModification', response => this.loadAll());
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    private paginateInsuranceCompanies(data: IInsuranceCompanyMySuffix[], headers: HttpHeaders) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.insuranceCompanies = data;
        this.insuranceCompanies.forEach(res => {
            if (res.isAccessPlatform) {
                res.accessStatus = 'Allowed'
            } else {
                res.accessStatus = 'Not allowed'
            }
        })
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    get authority() {
        return this.principal.userIdentity.authorities[0];
    }
    searchItems() {
        if (this.searchText) {
            let pNo = 0;
             let size = this.itemsPerPage;
            if (CommonUtils.isTrue(this.flag)) {
                pNo = this.page - 1;
                size = this.itemsPerPage;
                this.flag = false;
            }
            this.principal
                .searchQuery(this.searchText, 'insurance-companies/search', {
                    page: pNo,
                    size: size,
                    sort: this.sort()
                })
                .subscribe(
                    (res: HttpResponse<IInsuranceCompanyMySuffix[]>) => this.paginateInsuranceCompanies(res.body, res.headers),
                    (res: HttpErrorResponse) => this.onError(res.message)
                );
        } else {
            this.loadAll();
        }
    }

    // global modal open and close event
    bsModalRef: BsModalRef;

    openInformationModel(insuranceCompany) {
        // if (insuranceCompany.id !== null && insuranceCompany.id !== undefined) {
        //     let form_data = {
        //         masterId: insuranceCompany.id,
        //         informationType: InformationType.INSURANCE_COMPANY.valueOf()
        //     }
        //     this.informationModelService.fetchExistedInformationDetailsByType(form_data).subscribe(response => {
        //         const resBody = response.body;
        //         if (resBody && resBody.length > 0) {
        //             const initialState = {
        //                 isUpdateType: false,
        //                 mainList: resBody,
        //             };
        //             this.bsModalRef = this.modalService.show(InformationModelComponent, { initialState, class: "modal-lg" });
        //             this.bsModalRef.content.onClose.subscribe(result => {
        //                 console.log(result);
        //             });
        //         } else {
        //             this.router.navigate(['/data-management', { outlets: { popup: 'insurance-company/'+ insuranceCompany.id + '/delete'} }]);
        //         }
        //     });
        // }


        // this.delegationService.checkForInsurerInDelegations(insuranceCompany.id).subscribe(res => {
        //     if(res&&res.body&&res.body.payload&&res.body.payload.length>0) {
        //         let deleg=res.body.payload as IDelegation[];
        //         let ids:string=deleg.map(item => item.delegationNumber).join(", ");
        //         this.jhiAlertService.error('Insurer is present in delegations '+ids);
        //     } else {
        //         // this.router.navigate(['/data-management', { outlets: { popup: 'underwriter-insurer-my-suffix/' + mainObject.id + '/delete' } }]);
        //         this.router.navigate(['/data-management', { outlets: { popup: 'insurance-company/'+ insuranceCompany.id + '/delete'} }]);
        //     }
        // });

        forkJoin([this.insuranceCompanyService.checkForInsurerInPolicy(insuranceCompany.id),this.delegationService.checkForInsurerInDelegations(insuranceCompany.id)])
            .subscribe(resp => {
                let policy:any=resp[ 0 ];
                let delg:any=resp[ 1 ];
                let msg='Insurer is present in';
                let isPresent=false;
                if((policy&&policy.body&&policy.body.payload&&policy.body.payload.length>0)) {
                    msg=msg+" policies "+policy.body.payload;
                    isPresent=true;
                }
                if(delg&&delg.body&&delg.body.payload&&delg.body.payload.length>0) {
                    msg=msg+" "+(isPresent? " and in delegations "+delg.body.payload:" delegations "+delg.body.payload);
                    isPresent=true;
                }

                if(isPresent) {
                    this.jhiAlertService.error(msg);
                } else {
                    this.openActivateModal('InActivate', insuranceCompany.id);
                }
        });

        // this.insuranceCompanyService.checkForInsurerInPolicy(insuranceCompany.id).subscribe(res => {
        //     if(res&&res.body&&res.body.payload&&res.body.payload.length>0) {
        //         this.jhiAlertService.error('Insurer is present in polices '+res.body.payload);
        //     } else {
        //         // this.router.navigate(['/data-management', { outlets: { popup: 'underwriter-insurer-my-suffix/' + mainObject.id + '/delete' } }]);
        //     }
        // });


    }

    // history
    parentHistoryToggle = false;
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;

    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewFutureHistory(Obj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Insurance Company (' + Obj.name + ') Future Records';
        this.historyType = "INSURANCE_COMPANIES_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Insurance Company (' + Obj.name + ') History';
        this.historyType = "INSURANCE_COMPANIES_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }
    onChange(value) {
        this.page = 0;
        this.itemsPerPage = value
        this.loadAll();
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }

    openActivateModal(status, id) {
        this.showActiveModel = true;
        this.insuranceCompanyId = id;
        if (status == 'ACTIVATE') {
            this.modalContent = 'Are you sure you want to activate this Insurance Company?'
            this.status = 'ACTIVE';
        } else {
            this.modalContent = 'Are you sure you want to In-activate this Insurance Company?'
            this.status = 'IN_ACTIVE'
        }
    }

    changeInsuranceCompanyStatus() {
        if (this.insuranceCompanyId) {
            this.insuranceCompanyService.delete(this.insuranceCompanyId).subscribe(response => {
                if (this.status == 'ACTIVE') {
                    this.jhiAlertService.success('The insurance company staff has been activated successfully')
                } else {
                    this.jhiAlertService.success('The insurance company has been de-activated successfully')
                }
                this.loadAll();
            });
        }
    }

    closeActiveModels(e: boolean) {
        this.showActiveModel = e;
    }

    hideinsuranceCompanyAccessModal() {
        this.insuranceCompanyAccessModal.hide();
    }

    openAccessModalPopup(status, company) {
        this.incCompanyName = company.name;
        this.accessClientId = company.id;
        this.isLoginEmail = company.loginEmailAddress ? company.loginEmailAddress : '';
        this.insuranceCompanyAccessModal.show();
        if (status == "Access") {
            this.accessPlatform = true;
        } else {
            this.accessPlatform = false;
        }
    }
    getAccessPermission() {
        if (this.accessClientId)
            this.insuranceCompanyService.accessPlatform(this.accessClientId).subscribe((p: any) => {
                if (p) {
                    this.loadAll();
                    this.jhiAlertService.success(p.body.message);
                }
            })
        this.hideinsuranceCompanyAccessModal();
    }
}
